import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const crumbleAuxPommes: Recipe = {
  slug: 'crumble-aux-pommes',
  title: 'Crumble aux pommes',
  category: 'sucré',
  description: 'Un crumble aux pommes à la cannelle, pour 6 personnes.',
  image: image('crumble-aux-pommes'),
  tags: ['pommes', 'dessert', 'cannelle'],
  meta: [
    { label: 'Préparation', value: '20 min' },
    { label: 'Cuisson', value: '30 min' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('pommes', 'pommes', '6 belles pommes', { amount: 6, unit: 'pomme', shoppingKey: 'pomme' }),
      ingredient('cassonade', 'cassonade', '150 g de cassonade', {
        amount: 150,
        unit: 'g',
        shoppingKey: 'cassonade',
      }),
      ingredient('farine', 'farine de blé', '150 g de farine de blé', {
        amount: 150,
        unit: 'g',
        shoppingKey: 'farine',
      }),
      ingredient('beurre', 'beurre', '125 g de beurre', { amount: 125, unit: 'g', shoppingKey: 'beurre' }),
      ingredient('cannelle', 'cannelle', 'Cannelle en poudre', { optional: true }),
    ]),
  ],
  steps: [
    'Peler, évider et découper les pommes en cubes grossiers. Les faire cuire environ 10 minutes à la poêle et les parsemer de cannelle.',
    'Mélanger la farine et la cassonade. Ajouter le beurre en petits cubes et mélanger avec le batteur plat à vitesse 2 de façon à former une pâte grumeleuse.',
    'Disposer les pommes dans un plat allant au four. Émietter la pâte au-dessus des pommes de façon à les recouvrir.',
    'Mettre au four une bonne demi-heure à 210 °C.',
  ],
}
